import React from "react";
import { ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { DriveBreadcrumb } from "@/state/googleDriveBrowserLegend";

type GoogleDriveBreadcrumbsProps = {
  breadcrumbs: DriveBreadcrumb[];
  onNavigate: (index: number) => void;
};

export const GoogleDriveBreadcrumbs = React.memo(function GoogleDriveBreadcrumbs({
  breadcrumbs,
  onNavigate,
}: GoogleDriveBreadcrumbsProps) {
  return (
    <nav
      className="flex flex-wrap items-center gap-1 text-sm text-muted-foreground"
      aria-label="Google Drive folder path"
    >
      {breadcrumbs.map((crumb, index) => (
        <React.Fragment key={crumb.id}>
          {index > 0 && <ChevronRight className="h-3.5 w-3.5 shrink-0" />}
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="h-7 px-2 text-sm font-normal"
            onClick={() => onNavigate(index)}
            disabled={index === breadcrumbs.length - 1}
          >
            {crumb.name}
          </Button>
        </React.Fragment>
      ))}
    </nav>
  );
});
